import { FormControl, FormControlLabel, FormLabel, Radio, styled } from "@mui/material";

export const FormContainer = styled(FormControl)(() => ({
    "& .MuiFormLabel-asterisk": {
        color: "#e5453b",
    },
}));

export const RadioContainer = styled(Radio)(() => ({
    "&:hover": {
        backgroundColor: "rgb(196 216 255 / 18%)",
        "& span": {
            boxShadow:
                "0px 2px 1px -1px rgb(0 0 0 / 8%), 0px 1px 1px 0px rgb(0 0 0 / 9%), 0px 0px 0px 0px rgb(0 0 0 / 12%)",
        },
    },
}));

export const FormLabelContainer = styled(FormLabel)(() => ({
    fontFamily: 'Roboto, sans-serif',
    fontSize: "14px",
    fontWeight: "bold",
    color: "#2c2f44",
    "&.Mui-focused": {
        color: "#2c2f44",
    },
}));

export const FormControlLabelText = styled(FormControlLabel)(() => ({
    textTransform: 'none',
}));

export const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#E6F3FF",
    border: "solid 1px #3398FF",
    ".Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2,
    },
    "input:disabled ~ &": {
        boxShadow: "none",
        background:
            theme.palette.mode === "dark" ? "rgba(57,75,89,.5)" : "rgb(0 0 0 / 12%)",
    },
}));

export const BpCheckedIcon = styled(BpIcon)({
    width: 16,
    height: 16,
    position: "relative",
    backgroundColor: "#E6F3FF",
    backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage: "radial-gradient(#2550FA, #2550FA 21%, transparent 32%)",
        content: '""',
        position: "absolute",
        top: -1,     
        left: -1,
    },
});